<template>
	<div class="footer-channel">
		<div class="footer-channel-content" :class="{ 'footer-channel-content-grid': channelCount > 1 }">
			<div v-for="(item, index) in getChannelList" :key="index" class="footer-channel-item">
				<div class="footer-channel-item-qrcode">
					<el-image :src="item.otherChannelImage" fit="cover" style="width: 100%; height: 100%" />
				</div>
				<div class="footer-channel-item-title text-overflow">{{ item.name }}</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useCommonData } from '@/hooks';

const { getChannelList } = useCommonData();
const channelCount = computed(() => getChannelList.value?.length || 0);
</script>

<style lang="less" scoped>
.footer-channel {
	display: flex;
	justify-content: center;

	.footer-channel-content-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 32px;
		justify-items: start;
	}

	.footer-channel-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;

		.footer-channel-item-qrcode {
			width: 100px;
			height: 100px;
			padding: 4px;
			background: #fff;
		}
		.footer-channel-item-title {
			color: rgba(var(--surf-inverse-color-rgb), 0.4);
			font-size: 12px;
			font-weight: 400;
			line-height: 16px;
			max-width: 130px;
		}
	}
}
</style>
